import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserService } from '../core/services/user.service';

/** The admin dashboard is for users with the Administrator role; anyone else goes back to the dashboard. */
export const adminGuard: CanActivateFn = () =>
  inject(UserService).isUserAdmin() || inject(Router).createUrlTree(['/dashboard']);
